"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryItems = [{
  id: "m1",
  title: "Modern Suburban Estate",
  description: "Spacious 4-bedroom home in Houston with a large backyard and private financing options. Low down payment available.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/houston_suburban_home.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/houston_suburban_home.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/houston_suburban_home.png-wvc-sizes",
  category: "Hot Deal"
}, {
  id: "m2",
  title: "Austin Contemporary Loft",
  description: "Luxury living with owner financing. Features floor-to-ceiling windows, 2 bedrooms, and off-street parking.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/austin_modern_loft.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/austin_modern_loft.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/austin_modern_loft.png-wvc-sizes",
  category: "New"
}, {
  id: "m3",
  title: "Dallas Family Residence",
  description: "Classic brick home with 3 bathrooms and a 2-car garage. Perfect for families looking for flexible financing terms.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/dallas_family_home.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/dallas_family_home.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/dallas_family_home.png-wvc-sizes",
  category: "Hot Deal"
}, {
  id: "m4",
  title: "San Antonio Ranch",
  description: "Expansive property with street parking and updated interiors. Monthly payments tailored to your budget.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/san_antonio_ranch.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/san_antonio_ranch.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/san_antonio_ranch.png-wvc-sizes",
  category: "New"
}, {
  id: "m5",
  title: "Louisiana Riverside Cottage",
  description: "Charming 3-bedroom home with scenic views. Owner financing makes this dream home accessible today.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/louisiana_riverside_home.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/louisiana_riverside_home.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/louisiana_riverside_home.png-wvc-sizes",
  category: "Hot Deal"
}, {
  id: "m6",
  title: "Fort Worth Executive Home",
  description: "High-end finishes, 5 bedrooms, and a gourmet kitchen. Secure this premium property with private financing.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/fort_worth_executive.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/fort_worth_executive.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/fort_worth_executive.png-wvc-sizes",
  category: "New"
}];
export default function AvailableInventory() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="255761" id="available-inventory" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        
        {}
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-primary mb-4">
            Available Inventory
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto mb-6 rounded-md"></div>
          <p className="text-muted-foreground font-default text-lg md:text-xl leading-relaxed">
            Explore our curated selection of owner-financed properties across the country. 
            Find your dream home with flexible terms and no traditional bank requirements.
          </p>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {galleryItems.map((item, i) => <div data-index={i} key={item.id} className="h-full">
              <Card className="h-full overflow-hidden border-border/50 transition-all duration-300 ease-out hover:shadow-xl hover:border-primary/20 group bg-card flex flex-col rounded-lg">
                <div className="relative overflow-hidden">
                  <AspectRatio ratio={4 / 3}>
                    <img src={item.imageSrc} data-wvc-srcset={item.imageSrcset} data-wvc-sizes={item.imageSizes} alt={item.title} className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-110" loading="lazy" />
                  </AspectRatio>
                  <div className="absolute top-3 right-3 z-10">
                    <Badge variant="secondary" className="bg-primary text-primary-foreground border-none shadow-md font-bold px-3 py-1">
                      {item.category}
                    </Badge>
                  </div>
                  {}
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-out">
                    <button className="bg-background text-foreground font-default font-semibold px-6 py-2 rounded-md shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                      Quick View
                    </button>
                  </div>
                </div>
                
                <CardContent className="p-6 flex-grow flex flex-col justify-start">
                  <h3 className="font-default text-xl font-bold mb-3 text-foreground group-hover:text-primary transition-colors duration-200 ease-out">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground font-default text-sm leading-relaxed">
                    {item.description}
                  </p>
                  <div className="mt-auto pt-4 flex items-center justify-between border-t border-border/30">
                    <span className="font-mono text-xs font-semibold text-primary uppercase tracking-wider">Owner Financed</span>
                    <span className="font-mono text-xs font-bold text-secondary">View Details →</span>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="mt-16 text-center">
          <button className="bg-primary hover:bg-primary/90 text-primary-foreground font-default font-bold px-10 py-4 rounded-md shadow-lg transition-all duration-200">
            Load More Properties
          </button>
        </div>

      </div>
    </section>;
}